import { motion } from 'framer-motion';

const items = [
  {
    icon: 'ri-search-2-line',
    title: 'Revisión de antecedentes del caso',
    desc: 'Analizamos la situación inicial, documentos del causante y número de herederos.',
  },
  {
    icon: 'ri-team-line',
    title: 'Determinación de herederos',
    desc: 'Identificamos y verificamos a todos los herederos legales del causante.',
  },
  {
    icon: 'ri-file-paper-2-line',
    title: 'Preparación y presentación de solicitud',
    desc: 'Redactamos y presentamos la solicitud ante la institución correspondiente.',
  },
  {
    icon: 'ri-bank-line',
    title: 'Tramitación ante Registro Civil o tribunal',
    desc: 'Gestionamos el proceso según corresponda: intestada (Registro Civil) o testamentaria (tribunal).',
  },
  {
    icon: 'ri-route-line',
    title: 'Seguimiento completo del proceso',
    desc: 'Te informamos en cada etapa hasta la resolución definitiva del trámite.',
  },
  {
    icon: 'ri-home-gear-line',
    title: 'Asesoría en inscripción de bienes',
    desc: 'Orientación para inscribir propiedades, vehículos y otros bienes a nombre de los herederos.',
  },
];

const PosesionIncludes = () => {
  return (
    <section className="py-14 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10"
        >
          <span className="inline-block bg-primary-yellow text-black text-xs font-black uppercase tracking-widest px-4 py-1.5 rounded-full mb-3">
            Qué incluye
          </span>
          <h2 className="text-3xl lg:text-4xl font-extrabold text-black mb-3">
            Todo lo que gestionamos por ti
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Un servicio completo, sin que tengas que preocuparte por los detalles administrativos y legales.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((item, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.08, duration: 0.5 }}
              className="group bg-gray-50 hover:bg-black rounded-2xl p-5 border border-gray-100 transition-all duration-300 cursor-default"
              style={{ willChange: 'transform, opacity' }}
            >
              <div className="w-10 h-10 flex items-center justify-center bg-primary-yellow rounded-xl mb-3 group-hover:bg-primary-yellow transition-colors duration-300">
                <i className={`${item.icon} text-black text-xl`}></i>
              </div>
              <h3 className="text-sm font-bold text-black group-hover:text-white mb-1.5 transition-colors duration-300 leading-snug">
                {item.title}
              </h3>
              <p className="text-sm text-gray-500 group-hover:text-gray-400 leading-relaxed transition-colors duration-300">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Summary bar */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="mt-8 bg-black rounded-2xl px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-4"
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-primary-yellow rounded-full flex-shrink-0">
              <i className="ri-checkbox-circle-line text-black text-xl"></i>
            </div>
            <p className="text-white text-sm font-medium">
              Proceso completo de inicio a fin — sin que debas ir a una sola oficina.
            </p>
          </div>
          <span className="text-primary-yellow font-black text-sm uppercase tracking-widest whitespace-nowrap">
            100% gestionado
          </span>
        </motion.div>
      </div>
    </section>
  );
};

export default PosesionIncludes;
